import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { withRadium } from "higher-order-components"
import { selectors } from "store/actions/mymazda"
import { LoaderIcon } from "components"
import componentParser from "AtomicUtils/componentParser"

const PageWithData = ({ isFetching, fetchError, components }) => {
  if (fetchError) {
    return null
  }
  if (!components.length) {
    if (isFetching) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            padding: "3em 0"
          }}>
          <LoaderIcon styleName="light" />
        </div>
      )
    }
    return null
  }
  return <div>{componentParser(components)}</div>
}

const mapStateToProps = (state, { location }) => ({
  ...selectors.getRoute(location.pathname)(state),
  components: selectors.getRouteComponents(location.pathname, location.search)(state) || []
})

PageWithData.propTypes = {
  isFetching: PropTypes.bool,
  fetchError: PropTypes.string,
  components: PropTypes.array
}

export default withRadium(
  connect(mapStateToProps, null)
)(PageWithData)



// WEBPACK FOOTER //
// ./src/containers/mymazda/page.jsx